export default "__VITE_ASSET__BWYw2Yeg__"